import { styled } from '@mui/material'

export const Navigation = styled('section')`
  width: 100%;
`

export const Root = styled('div')`
  padding-block: 32px;
  width: 100%;
`
